import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <section className="section listing_page">
      <div className="row justify-content-center g-0">
        <div className="col-md-10 col-lg-8">
          <div className="middle-page-content text-center py-5">
            <h2 className="mb-3">No data found</h2>
            <p className="mb-4">
              The page you are looking for doesn&apos;t exist or the link is
              invalid.
            </p>
            {/* <Link to="/" className="btn underline">
              Go back to Home
            </Link> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
